import LocalFireDepartmentOutlined from "@mui/icons-material/LocalFireDepartmentOutlined";
import { Box, Typography } from "@mui/material";

export interface SprintStreakCardEmptyStateProps {}

export function SprintStreakCardEmptyState({}: SprintStreakCardEmptyStateProps) {
  const icon = (
    <Box
      sx={{
        marginTop: 4.7,
        "& svg": {
          width: 36,
          height: 36,
          color: "text.secondary",
        },
      }}
    >
      <LocalFireDepartmentOutlined />
    </Box>
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "calc(100% - 24px)",
        gap: { xs: 2, sm: 1 },
        p: { xs: 2, sm: 3 },
        textAlign: "center",
      }}
    >
      {icon}

      <Box
        sx={{
          maxWidth: {
            xs: "100%",
            sm: 420,
          },
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: "700",
            fontSize: { xs: "16px", sm: "24px" },
            mb: { xs: 1, sm: 1.5 },
          }}
        >
          No sprint streak data available
        </Typography>
      </Box>
    </Box>
  );
}
